<mip-toolbar
  *ngIf="profile"
  class="profile-top-toolbar"
  [noDropShadow]="isMobile"
  [goBackFallback]="backFallbackReferrer"
  [goBackReferrer]="backPathReferrer"
  [roundedBackButton]="isDesktop"
  [largerTheme]="isDesktop"
  [class.--is-mobile]="isMobile"
  [class.--is-desktop]="isDesktop"
  [class.--is-authenticated]="profile.isAuthenticated"
>
  <a class="__profile-slug-name" mat-button>
    <mip-profile-slug-name [user]="profile"></mip-profile-slug-name>
  </a>

  <div class="__bar-action">
    <button class="__action __share" mat-button (click)="shareProfile()">
      <mip-icon icon="share" [solid]="true"></mip-icon>
    </button>

    <mip-profile-options [profile]="profile" *ngIf="isMobile && profile.isAuthenticated"></mip-profile-options>
  </div>
</mip-toolbar>
